import React, { useEffect } from 'react';

import BannersAero from './BannersAero';
import IncrementCounter from './IncrementCounter';
//  import Testimonials from './Testimonials';
import Digitalhiringbanner from './Digitalhiringbanner';
import DigitalMarketingapplaypage from './DigitalMarketingapplaypage';


const Digitalmarketinpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <Digitalhiringbanner />
  <DigitalMarketingapplaypage />
      {/* <Digtalmarketingrequestform  /> */}
      <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style>
    </div>
  )
}

export default Digitalmarketinpage;